__turbopack_context__.v({
  "className": "public_sans_ee364fa1-module__QxPNNW__className",
});
